import * as PIXI from 'pixi.js-legacy';
import Item from '../Item';
import productsService from '../../services/products';
import { ITEMS } from '../../constants';

export default class ShelvingUnit extends Item {
  draw() {
    const { scaledVertices } = this.data;

    this.legsContainer = this.legsContainer || new PIXI.Container();
    this.legsContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.legsContainer.parent) {
      this.addChild(this.legsContainer);
    }

    this.stackContainer = this.stackContainer || new PIXI.Container();
    this.stackContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    super.draw();

    if (!this.stackContainer.parent) {
      this.addChild(this.stackContainer);
    }
  }

  eraseDropAreas() {
    this.stackContainer.children.forEach(child => child.eraseDropAreas());
    super.eraseDropAreas();
  }

  getAllChildren() {
    return this.childrenContainer.children.concat(this.stackContainer.children);
  }

  getContainer(sprite) {
    if (productsService.isType(sprite.item, 'leg')) {
      return this.legsContainer;
    }
    if (
      productsService.isType(sprite.item, [ITEMS.FRAME, ITEMS.SHELVING_UNIT])
    ) {
      return this.stackContainer;
    }

    return super.getContainer(sprite);
  }
}
